(function () {
  var headers = document.querySelectorAll('.makc-footer__accordion-header');
  var desktopMql = window.matchMedia('(min-width: 1024px)');

  function handleToggle() {
    var expanded = this.getAttribute('aria-expanded') === 'true';
    this.setAttribute('aria-expanded', String(!expanded));
  }

  // Desktop renders these as static flat columns (see the @media block in
  // makc-footer.css) -- headers must not be reachable or announced as
  // expand/collapse controls there, since activating them has no visible
  // effect. role="presentation" strips the <button>'s implicit widget
  // semantics; tabindex="-1" removes it from the tab order. Re-run on every
  // breakpoint crossing, not just on load, so resizing across 1024px
  // without a reload still ends up in the correct state.
  function syncInteractivity() {
    var isDesktop = desktopMql.matches;
    headers.forEach(function (header) {
      header.removeEventListener('click', handleToggle);
      if (isDesktop) {
        header.setAttribute('tabindex', '-1');
        header.setAttribute('role', 'presentation');
      } else {
        header.removeAttribute('tabindex');
        header.removeAttribute('role');
        header.addEventListener('click', handleToggle);
      }
    });
  }

  syncInteractivity();

  if (typeof desktopMql.addEventListener === 'function') {
    desktopMql.addEventListener('change', syncInteractivity);
  } else if (typeof desktopMql.addListener === 'function') {
    desktopMql.addListener(syncInteractivity);
  }
})();

(function () {
  var form = document.getElementById('makc-footer-newsletter-form');
  if (!form) return;

  var right = form.querySelector('.makc-footer__newsletter-right');
  var emailInput = form.querySelector('.makc-footer__newsletter-input');
  var ERROR_DELAY_MS = 600;
  var errorTimer = null;

  // Scroll restore -- the one sitewide exception to "the customer lands
  // at the top" (CLAUDE.md, "Scroll position"). This form is Shopify's
  // native {% form 'customer' %}: a valid submit POSTs for real and
  // Shopify redirects back with ?customer_posted=true, which is what
  // makes form.posted_successfully? true on the next render. A fragment
  // cannot survive that -- fragments are never sent to the server -- so
  // the browser lands at the top of the page while the Success or Error
  // message the customer is waiting for sits in the footer, off screen.
  //
  // Read straight off the state the Liquid rendered
  // (sections/makc-footer.liquid), before any listener below can change
  // it, so only a genuine server result scrolls; nothing the customer
  // types afterwards does.
  //
  // Deliberately local: this reads the newsletter's own state and moves
  // the window once, on load. It shares nothing with the cart, sheets,
  // filter or page navigation -- no scroll lock, no close(onClosed), no
  // common land-at-top helper -- so it cannot affect them.
  var serverState = right.getAttribute('data-state');
  if (serverState === 'success' || serverState === 'error') {
    var section = form.closest('.makc-footer__newsletter') || right;
    // behavior is left at its default rather than passed explicitly: it
    // resolves to instant here (nothing sets scroll-behavior: smooth
    // globally -- theme.css only ships it as an opt-in .scroll-smooth
    // utility), and an explicit "instant" is an enum value old browsers
    // reject outright. Deferred scripts run before first paint, so the
    // page renders already in position instead of visibly jumping.
    section.scrollIntoView({ block: 'center' });
  }

  function isCompleteValidEmail() {
    return emailInput.value.trim() !== '' && emailInput.checkValidity();
  }

  function isInvalidNonEmpty() {
    return emailInput.value.trim() !== '' && !emailInput.checkValidity();
  }

  // Every keystroke re-evaluates immediately (button activates the moment
  // the content looks like a complete, valid email; anything else clears
  // back to resting, which is also what makes a shown Error disappear the
  // instant they resume typing) and restarts the debounce -- Error only
  // actually renders once 600ms passes with invalid, non-empty content
  // untouched, so a genuinely wrong/abandoned entry gets caught without
  // flashing Error on every incomplete keystroke while typing normally.
  function handleInput() {
    clearTimeout(errorTimer);

    if (isCompleteValidEmail()) {
      right.setAttribute('data-state', 'focus');
    } else {
      right.removeAttribute('data-state');
    }

    if (isInvalidNonEmpty()) {
      errorTimer = setTimeout(function () {
        right.setAttribute('data-state', 'error');
      }, ERROR_DELAY_MS);
    }
  }

  // Re-engaging with a field showing a stale error (client- or
  // server-rendered from form.errors on reload) shouldn't keep punishing
  // them before they've had a chance to fix it.
  function handleFocus() {
    if (right.getAttribute('data-state') === 'error') {
      right.removeAttribute('data-state');
    }
  }

  // The other Error trigger alongside the pause-debounce above: leaving
  // the field with invalid, non-empty content still present is judged
  // immediately rather than waiting out the timer.
  function handleBlur() {
    clearTimeout(errorTimer);
    if (isInvalidNonEmpty()) {
      right.setAttribute('data-state', 'error');
    }
  }

  // novalidate on the form hands constraint validation to us so the built
  // Error state renders instead of the browser's native bubble --
  // checkValidity() still runs the browser's own email-format check
  // (required on the input makes it correctly catch an empty submit too).
  function handleSubmit(event) {
    if (!emailInput.checkValidity()) {
      event.preventDefault();
      clearTimeout(errorTimer);
      right.setAttribute('data-state', 'error');
    }
  }

  function handleDismiss() {
    right.removeAttribute('data-state');
  }

  emailInput.addEventListener('input', handleInput);
  emailInput.addEventListener('focus', handleFocus);
  emailInput.addEventListener('blur', handleBlur);
  form.addEventListener('submit', handleSubmit);
  form.querySelectorAll('.makc-footer__newsletter-toast-dismiss').forEach(function (button) {
    button.addEventListener('click', handleDismiss);
  });
})();
